import { Action, State, StateContext } from '@ngxs/store';
import { Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { AttendanceStatusService } from '../../services/attendance-status/attendance-status.service';
import { AttendanceStatus } from '../../interfaces/attendanceStatus';
import { AttendanceStatusActions } from './attendance-status.actions';

export class AttendanceStatusStateModel {
  public attendanceStatus: AttendanceStatus[];
}

const defaults = {
  attendanceStatus: [],
};

@State<AttendanceStatusStateModel>({
  name: 'attendanceStatus',
  defaults,
})
@Injectable()
export class AttendanceStatusState {
  constructor(private attendanceStatusService: AttendanceStatusService) {}

  @Action(AttendanceStatusActions.GetAttendanceStatus)
  getAttendanceStatus({
    getState,
    setState,
  }: StateContext<AttendanceStatusStateModel>): Observable<AttendanceStatus[]> {
    return this.attendanceStatusService.getAttendanceStatus().pipe(
      tap((attendanceStatus: AttendanceStatus[]) => {
        const state = getState();
        setState({ ...state, attendanceStatus });
      })
    );
  }
}
